import { createSelector } from '@reduxjs/toolkit';
import { selectSaleTypes } from 'shared/selectors/jsonQuery';
import { prepareValue } from './utils';
import { NEWBUILDING_SALE_TYPES } from 'shared/constants/saleTypeValues';

export const selectNewbuildingSaleTypeValue = createSelector(selectSaleTypes, value =>
  prepareValue({ value, allowedValues: NEWBUILDING_SALE_TYPES }),
);
